/** Imports */
import {z} from 'zod';
import {zGroup} from '@/db/schema/groups';
import {zPage} from '@/mongoSchemas/Page/Pages.zod';
import {zMongoObject, zMongoObjectId} from '@/types/utils';
import {zOrganization} from '@/mongoSchemas/Organization/Organizations.zod';


/** Types */
export type Dashboard = z.infer<typeof zDashboard>;


/// Zod schemas
export const zDashboard = zMongoObject.extend({
    get organization() {
        return z.union([
            zMongoObjectId,
            zOrganization,
        ]);
    },
    get pages() {
        return z.union([
            zMongoObjectId,
            zPage,
        ]).array();
    },
    get groups() {
        return z.union([
            z.number().int().positive(),
            zGroup,
        ]).array();
    },
    name: z.string(),
    notes: z.string().optional(),
    postingCountDaily: z.record(z.string(), z.record(z.string(), z.number())).default(() => ({})),
});
